global.FR = global.FR || {};
import website from './core-website';

global.FR.website = website;
